// assets/collection-load-more.js
(() => {
  const BTN_SEL = '[data-load-more-btn]';
  const GRID_SEL = '.product-grid';
  const ITEM_SEL = '.product-grid__item';
  const WRAP_SEL = '[data-load-more-wrap]';

  function getCols(grid) {
    const tpl = getComputedStyle(grid).gridTemplateColumns;
    const n = tpl ? tpl.split(' ').filter(Boolean).length : 1;
    return n || 1;
  }

  function missingToFillRow(total, cols) {
    const r = total % cols;
    return r === 0 ? 0 : (cols - r);
  }

  async function fetchDoc(url) {
    const res = await fetch(url, { credentials: 'same-origin' });
    if (!res.ok) throw new Error(`HTTP ${res.status}`);
    const html = await res.text();
    return new DOMParser().parseFromString(html, 'text/html');
  }

  function getNextUrlFromDoc(doc) {
    const btn = doc.querySelector(BTN_SEL);
    return btn?.getAttribute('data-next-url') || '';
  }

  function getItemsFromDoc(doc) {
    const nextGrid = doc.querySelector(GRID_SEL);
    if (!nextGrid) return [];
    return Array.from(nextGrid.querySelectorAll(ITEM_SEL));
  }

  function endOfList(btn) {
    btn.remove();
    const wrap = document.querySelector(WRAP_SEL);
    if (wrap) wrap.insertAdjacentHTML('beforeend', `<div class="collection-load-more__end">Hai visto tutto ✨</div>`);
  }

  async function loadMore(btn) {
    const grid = document.querySelector(GRID_SEL);
    if (!grid) return;

    let nextUrl = btn.getAttribute('data-next-url');
    if (!nextUrl) return;

    const original = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Caricamento…';

    try {
      // 1) fetch pagina successiva e append TUTTI gli item
      const doc1 = await fetchDoc(nextUrl);
      const items1 = getItemsFromDoc(doc1);
      items1.forEach((li) => grid.appendChild(li));

      let newNextUrl = getNextUrlFromDoc(doc1);
      btn.setAttribute('data-next-url', newNextUrl);

      // 2) prova a chiudere l’ultima riga con AL MASSIMO un secondo fetch
      const cols = getCols(grid);
      const total = grid.querySelectorAll(ITEM_SEL).length;
      let need = missingToFillRow(total, cols);

      // se serve e c’è ancora nextUrl, fai un secondo fetch e append SOLO i necessari
      if (need > 0 && newNextUrl) {
        const doc2 = await fetchDoc(newNextUrl);
        const items2 = getItemsFromDoc(doc2);

        items2.slice(0, need).forEach((li) => grid.appendChild(li));

        // aggiorna nextUrl alla “pagina dopo” (anche se abbiamo usato solo una parte)
        // NB: qui “salti” alcuni prodotti della doc2, MA è accettabile come compromesso
        // per avere sempre righe piene senza buffer complessi.
        newNextUrl = getNextUrlFromDoc(doc2);
        btn.setAttribute('data-next-url', newNextUrl);
      }

      // fine lista?
      if (!btn.getAttribute('data-next-url')) {
        endOfList(btn);
        return;
      }

      btn.disabled = false;
      btn.textContent = original;
    } catch (e) {
      console.error('[load-more] error', e);
      btn.disabled = false;
      btn.textContent = 'Riprova';
    }
  }

  // Capture phase: batte eventuali handler del tema
  document.addEventListener(
    'click',
    (e) => {
      const btn = e.target.closest(BTN_SEL);
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();
      if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();
      loadMore(btn);
    },
    true
  );
})();